export default __webpack_public_path__ + "static/media/43.5d69c06b.jpg";